import { enumPersistableObjectType } from '..';
import { MdbError } from '../../../errorObjects/MdbError';
import { enumMdbErrorType } from '../../../errorObjects/enums';
import { TopicItem } from '../../models/topics/TopicItem';

/**
 * @class enumPersistableObjectTypeConvert Provides to/from string conversions for enumPersistableObjectType values.
 */
export class enumPersistableObjectTypeConvert {
  public static toString(persistableObjectTypeEnum: enumPersistableObjectType): string {
    return persistableObjectTypeEnum.toString();
  }

  public static fromString(persistableObjectTypeString: string): enumPersistableObjectType {
    let persistableObjectTypeEnum: enumPersistableObjectType = enumPersistableObjectType.Channel;

    switch (persistableObjectTypeString) {
      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.AudioLink):
        persistableObjectTypeEnum = enumPersistableObjectType.AudioLink;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.Category):
        persistableObjectTypeEnum = enumPersistableObjectType.Category;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.CategoryAssociation):
        persistableObjectTypeEnum = enumPersistableObjectType.CategoryAssociation;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.CategoryMetadata):
        persistableObjectTypeEnum = enumPersistableObjectType.CategoryMetadata;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.Channel):
        persistableObjectTypeEnum = enumPersistableObjectType.Channel;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.ChannelMetadata):
        persistableObjectTypeEnum = enumPersistableObjectType.ChannelMetadata;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.DigitalMedia):
        persistableObjectTypeEnum = enumPersistableObjectType.DigitalMedia;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.DocumentLink):
        persistableObjectTypeEnum = enumPersistableObjectType.DocumentLink
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.EmailRequest):
        persistableObjectTypeEnum = enumPersistableObjectType.EmailRequest;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.HyperLink):
        persistableObjectTypeEnum = enumPersistableObjectType.HyperLink;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.ImageLink):
        persistableObjectTypeEnum = enumPersistableObjectType.ImageLink;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.LocaleTranslation):
        persistableObjectTypeEnum = enumPersistableObjectType.LocaleTranslation;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.Membership):
        persistableObjectTypeEnum = enumPersistableObjectType.Membership;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.MembershipSubscription):
        persistableObjectTypeEnum = enumPersistableObjectType.MembershipSubscription;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.Note):
        persistableObjectTypeEnum = enumPersistableObjectType.Note;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.ObjectSharingRequestTracker):
        persistableObjectTypeEnum = enumPersistableObjectType.ObjectSharingRequestTracker;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.PersistenceMetadata):
        persistableObjectTypeEnum = enumPersistableObjectType.PersistenceMetadata;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.PersistenceCreateMetadata):
        persistableObjectTypeEnum = enumPersistableObjectType.PersistenceCreateMetadata;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.PersistenceDeleteMetadata):
        persistableObjectTypeEnum = enumPersistableObjectType.PersistenceDeleteMetadata;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.PersistenceUpdateMetadata):
        persistableObjectTypeEnum = enumPersistableObjectType.PersistenceUpdateMetadata;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.PersistenceUserDeviceMetadata):
        persistableObjectTypeEnum = enumPersistableObjectType.PersistenceUserDeviceMetadata;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.SocialMediaPost):
        persistableObjectTypeEnum = enumPersistableObjectType.SocialMediaPost;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.ThemeSpecs):
        persistableObjectTypeEnum = enumPersistableObjectType.ThemeSpecs;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.ThemeSpecsMetadata):
        persistableObjectTypeEnum = enumPersistableObjectType.ThemeSpecsMetadata;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.Topic):
        persistableObjectTypeEnum = enumPersistableObjectType.Topic;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.TopicMetadata):
        persistableObjectTypeEnum = enumPersistableObjectType.TopicMetadata;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.TopicItem):
        persistableObjectTypeEnum = enumPersistableObjectType.TopicItem;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.TopicItemMetadata):
        persistableObjectTypeEnum = enumPersistableObjectType.TopicItemMetadata;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.User):
        persistableObjectTypeEnum = enumPersistableObjectType.User;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.UserCategories):
        persistableObjectTypeEnum = enumPersistableObjectType.UserCategories;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.UserFeedback):
        persistableObjectTypeEnum = enumPersistableObjectType.UserFeedback;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.UserRedemptionCodeRequest):
        persistableObjectTypeEnum = enumPersistableObjectType.UserRedemptionCodeRequest;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.UserSettings):
        persistableObjectTypeEnum = enumPersistableObjectType.UserSettings;
        break;

      case enumPersistableObjectTypeConvert.toString(enumPersistableObjectType.VideoLink):
        persistableObjectTypeEnum = enumPersistableObjectType.VideoLink;
        break;

      default:
        throw new MdbError(`enumPersistableObjectTypeConvert.fromString. Unrecognized/unsupported enumPersistableObjectType string: ${persistableObjectTypeString}`, enumMdbErrorType.InvalidOperation);
    }

    return persistableObjectTypeEnum;
  }
}